<template>
    <div v-if="ticketType && ticketType.Description" class="rules my-5">
        {{ ticketType.Description }}
    </div>
</template>
<script lang="ts">
    import { defineComponent, PropType } from 'vue';
    import { FerryTicketType } from '@/api/Cart/cart.interfaces';

    export default defineComponent({
        name: 'FerryModalTerms',
        components: {},
        props: {
            ticketType: {
                type: Object as PropType<FerryTicketType | null>,
                required: true,
            },
        },
        setup() {
            return {};
        },
    });
</script>

<style lang="scss" scoped>
    .rules {
        line-height: 20px;
    }
</style>
